exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".benefits-view {\n  height: 100%;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n\n.benefits-view .benefits {\n  flex: 1;\n  overflow-y: scroll;\n}\n\n.benefits-view button {\n  margin-top: 3rem;\n  margin-bottom: 2rem;\n}\n\n.benefit-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 14rem;\n  border-bottom: 1px solid #E6E6E6;\n  padding: 0 3rem;\n}\n\n.benefit-row>.input {\n  width: 25rem;\n}\n\n", ""]);

// exports
